import Card from "components/common/Card";
import ButtonOutline from "components/semantic/ButtonOutline";
import success from "assets/gifs/success.gif";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { getSinglePolicy } from "store/thunk/kyp.thunk";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { ALL_POLICY_TYPES } from "utils/utils";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const param: any = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSinglePolicy(param?.policyId));
  }, []);

  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.policyData);

  const navigationHandler = () => {
    if (policyData.policyTypeId === ALL_POLICY_TYPES.LIFE) {
      navigate(`/kyp/kyp-life-result/${param.policyId}`);
    } else if (policyData.policyTypeId === ALL_POLICY_TYPES.MOTOR) {
      navigate(`/kyp/motor-benefit-summary/${param.policyId}`);
    } else if (policyData?.isDetailedKyp) {
      navigate(`/kyp/benefit-summary/${param?.policyId}`);
    } else navigate(`/kyp/kyp-health-result/${param.policyId}`);
  };

  return (
    <div className="flex justify-center items-center">
      <div className="w-full max-w-md">
        <Card className="w-full flex flex-col justify-center items-center px-6 py-10 gap-4">
          <img src={success} alt="Success" className="mb-2" />
          <div className="text-center">
            <p className="font-extrabold text-2xl text-[#00BF8B] leading-snug sm:text-xl">Congratulations!</p>
            <p className="text-base font-medium text-[#5F5F5F] mt-1 sm:text-sm">Explore KYP results now</p>
          </div>
          <ButtonOutline title="GO TO KYP RESULTS" className="w-full sm:w-auto mt-4" onClick={navigationHandler} />
        </Card>
      </div>
    </div>
  );
};
